import { Info } from "lucide-react";
import { TabHeader } from "~/pages/manifold-nextgen/components/TabHeader";
import usePersonalDatasetTables from "~/pages/manifold-nextgen/hooks/usePersonalDatasetTables";
import { PersonalDatasetTableList } from "./tables/PersonalDatasetTableList";

export const PersonalDatasetTables = () => {
  const { data: tables } = usePersonalDatasetTables();
  const hasTables = (tables?.length ?? 0) > 0;

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-4">
      <TabHeader title="Tables" />
      {hasTables && (
        <div className="flex items-start gap-2 rounded-lg border border-primary/20 bg-primary/5 p-4 text-sm text-foreground">
          <Info className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" />
          <p>
            Agents write draft tables and views into your Snowflake schema — visible only to you
            until you promote one into a dataset you own.
          </p>
        </div>
      )}
      <PersonalDatasetTableList />
    </div>
  );
};
